import { CustomSkeletonTheme } from './CustomSkeletonTheme';

export type { TypeCustomSkeletonThemeProps } from './types';
export default CustomSkeletonTheme;
